export default {
  statistics: state => state.statistics,
  isDataLoaded: state => component => state.dataLoaded[component] || false,
  groupBy: state => state.groupBy,
  componentsByRights: state => state.rights,
  statisticByComponent: state => (type, component) => state.statistics[type][component],

};
